<template>
  <div style="padding-top: 30px">
    <div style="padding-bottom: 30px">
      <p class="navadno-besedilo">
        Wi-Fi je brezžična tehnologija, ki omogoča pametnim telefonom, tablicam, računalnikom in drugim
        digitalnim napravam brezžičen dostop do internetnega omrežja. <br v-if="prikazTabele === '1'">
        Izbirate lahko med običajnim brezžičnim omrežjem ali pametno brezžično mrežo.
      </p>
    </div>
    <div v-loading="nalaganjePaketovWifi">
      <div class="postavitev-wifi-mesh">
        <div class="postavitev-box-slika-wifi-mesh">
          <div class="box-wifi-mesh">
            <div style="text-align: center">
              <p class="open-sans-24pt">
                WiFi Pametna mreža
              </p>
            </div>
            <div style="text-align: center; padding-top: 10px">
              <img class="oblika-slike" :src="storitevPovezava.imgUrl">
            </div>
          </div>
        </div>
        <div class="postavitev-opisa-gumba">
          <div>
            <div>
              <p class="navadno-besedilo">
                Pametna Wi-Fi mreža pripelje Wi-Fi <b> signal v vsak kotiček vašega doma </b> in s pomočjo stabilnega
                Wi-Fi omrežja zagotavlja brezskrbno brskanje, gledanje serij, filmov in vsega, kar želite.
                <br v-if="prikazTabele === '1'">Z njo lahko ojačate <b> vaš Wi-fi signal </b> in dosežete vse prostore
                v vašem stanovanju ali hiši. Naj bodo to otroške sobe, vaše domače pisarne ali drugi prostori, v
                katerih potrebujete <b> zanesljivo internetno povezavo</b>.
              </p>
            </div>
            <div style="padding-top: 20px">
              <a :href="storitevPovezava.link" target="_blank">
                <el-button class="gumb-potrdi">
                  PREBERITE VEČ
                </el-button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"/>
      <izdelki-box class="pt-6">
        <template v-for="pvp in storitevZaIzpis">
          <izdelek
            :title="pvp.naziv.toUpperCase()"
            :tag="pvp.vPaketu ? 'VKLJUČENO V PAKET' : null"
            :key="pvp.naziv"
          >
            <template v-slot:icon/>
            <template v-slot:footer>
              <div class="cena">{{formatPrice(pvp.vPaketu ? 0 : pvp.cena)}} / mesec</div>
              <div class="orderButtonContainer">
                <OrderButton
                  v-if="!pvp.vPaketu"
                  :services="[{
                        serviceId: pvp.idStoritevVrstaIzbira,
                        quantity: pvp.vklopljena ? 0 : kolicinaZaNarocanje,
                        terminationPointId: Number.parseInt(izbranPrikljucek)
                      }]"
                  :custom-notify-text="GetTekstSpremembaWifiOpreme(pvp)"
                  service-name=""
                  @orderConfirmed="OsveziPodatke()"
                  :disabled="pvp.narocena"
                >
                  {{
                    pvp.narocena
                      ? 'NAROČENA'
                      : pvp.vklopljena
                        ? 'ODJAVI'
                        : 'NAROČI'
                  }}
                  <template slot="additionalDataInputs" v-if="!pvp.vklopljena">
                    <div class="mb-2">
                      <el-select v-model="kolicinaZaNarocanje" class="kolicina-narocanje mb-3">
                        <el-option
                          v-for="option in numbers"
                          :value="option"
                          :label="option"
                          :key="option">
                        </el-option>
                      </el-select>
                    </div>
                  </template>
                </OrderButton>
                <el-button
                  v-else
                  :class="pvp.vklopljena ? 'gumb-crni-okvir' : 'gumb-potrdi'"
                  :disabled="pvp.narocena"
                  :loading="pvp.loading"
                  @click="narociWifiStoritev(pvp.idStoritevVrstaIzbira, pvp.vklopljena ? 0 : (pvp.idStoritevVrstaIzbira === 1090 ? 1 : undefined), pvp)"
                >
                  {{pvp.vklopljena ? 'ODJAVI' : (pvp.narocena ? 'NAROČENA' : 'VKLOPI')}}
                </el-button>
              </div>
              <div v-if="pvp.vPaketu" class="rednaCena">Redna cena: {{formatPrice(pvp.cena)}} / mesec</div>
            </template>
            <div class="opisAlineja px-2">
              <div style="text-align: justify">{{pvp.opis}}</div>
            </div>
          </izdelek>
        </template>
      </izdelki-box>
    </div>

    <div style="padding-top: 40px" v-if="seznamVklopljenihZaIzpis.length > 0" v-loading="nalganjeVklopljenihStoritev">
      <div v-if="prikazTabele === '1'"
           style="padding-top: 30px; padding-bottom: 30px">
        <p class="open-sans-20pt">
          Vklopljene storitve
        </p>
        <el-table :data="seznamVklopljenihZaIzpis">
          <el-table-column prop="opis"
                           label="Storitev">
          </el-table-column>
          <el-table-column prop="trajanjeOd"
                           label="Datum naročila">
          </el-table-column>
          <el-table-column prop="kolicina"
                           label="Naročena količina">
          </el-table-column>
          <el-table-column prop="status"
                           label="Status naročila">
          </el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope">
              <el-tooltip class="item primarna-barva"
                          content="ODJAVI"
                          placement="right"
              >
                <OrderButton
                  v-if="!scope.row.jeVPaketu"
                  :services="[{
                        serviceId: scope.row.idStoritev,
                        quantity: 0,
                        terminationPointId: Number.parseInt(izbranPrikljucek)
                      }]"
                  class="postavitev-gumb-narocanje"
                  :service-name="scope.row.naziv.toLowerCase()"
                  @orderConfirmed="OsveziPodatke()"
                >
                  <template v-slot:buttonOverride>
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer">
                  </template>
                </OrderButton>
                <el-button
                  v-else
                  type="text"
                  style="color: #111820;"
                  :loading="pvp.loading"
                  @click="narociWifiStoritev(scope.row.idStoritev, 0, pvp)"
                >
                  <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer" class=" ma-auto ml-1">
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="prikazTabele === '0'">
        <p class="open-sans-20pt">
          Vklopljene storitve
        </p>
        <el-table :data="seznamVklopljenihZaIzpis"
                  :row-key="row => row.idStoritev"
                  :expand-row-keys="expandRowKeys"
                  @expand-change="IzbiraVrsticeZaPrikazVklopljenihStoritev">
          <el-table-column
            prop="opis"
            label="Tip Storitev">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding-top: 20px">
                <el-form label-width="150px" :label-position="formaOrientacija">
                  <el-form-item label="Datum naročila:">
                    {{ scope.row.trajanjeOd }}
                  </el-form-item>
                  <el-form-item label="Naročena količina:">
                    {{ scope.row.kolicina }}
                  </el-form-item>
                  <el-form-item label="Status naročila:">
                    Naročeno
                  </el-form-item>
                </el-form>
                <OrderButton
                  v-if="!scope.row.jeVPaketu"
                  :services="[{
                      serviceId: scope.row.idStoritev,
                      quantity: 0,
                      terminationPointId: Number.parseInt(izbranPrikljucek)
                    }]"
                  :service-name="scope.row.naziv.toLowerCase()"
                  @orderConfirmed="OsveziPodatke()"
                >
                  <template v-slot:buttonOverride>
                    <div class="odstrani-gumb mb-4">
                    ODJAVI <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer">
                    </div>
                  </template>
                </OrderButton>
                <el-button
                  v-else
                  type="text"
                  style="color: #111820;"
                  @click="narociWifiStoritev(scope.row.idStoritev, 0, pvp)"
                  :loading="pvp.loading"
                >
                  ODJAVI <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg" style="cursor: pointer" class=" ma-auto ml-1">
                </el-button>
              </div>
              <div style="clear: both"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-if="seznamNarocenihIzpis.length > 0" v-loading="nalganjeNarocenihStoritev">
      <div v-if="prikazTabele === '1'" style="padding-top: 30px; padding-bottom: 30px">
        <p class="open-sans-20pt">
          Naročene storitve
        </p>
        <el-table :data="seznamNarocenihIzpis">
          <el-table-column prop="opis" label="Storitev">
          </el-table-column>
          <el-table-column prop="trajanjeOd" label="Datum naročila">
          </el-table-column>
          <el-table-column prop="kolicina" label="Naročena količina">
          </el-table-column>
          <el-table-column prop="" label="Status naročila">
            <template>
              V obdelavi
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="prikazTabele === '0'" class="my-5">
        <p class="open-sans-20pt">
          Naročene storitve
        </p>
        <el-table :data="seznamNarocenihIzpis"
                  :row-key="row => row.idStoritev"
                  :expand-row-keys="expandRowKeys"
                  @expand-change="IzbiraVrsticeZaPrikazNarocenihStoritev">
          <el-table-column
            prop="opis"
            label="Tip Storitev">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding-top: 20px">
                <el-form label-width="155px" :label-position="formaOrientacija">
                  <el-form-item label="Datum naročila:">
                    {{ scope.row.trajanjeOd }}
                  </el-form-item>
                  <el-form-item label="Naročena količina:">
                    {{ scope.row.kolicina }}
                  </el-form-item>
                  <el-form-item label="Status naročila:">
                    V obdelavi
                  </el-form-item>
                </el-form>
                <div style="clear: both"/>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <order-exists-info/>
    </div>
    <div style="clear: both"/>
    <div class="odmik-wifi-nastavitve" v-if="prikaziGumbZaNastavitev">
      <a href="/Nastavitve/NastavitveMreznaOprema" class="okvir-sprememba-kontaktov tekst-kontaktnih-podatkov">
        PREVERI NASTAVITVE BREZŽIČNEGA OMREŽJA
      </a>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {Select, Option, Form, Button, Col, Tooltip, MessageBox} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum.js'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import Order from '../../../../../assets/js/Order/Order'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'
import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'

export default {
  name: 'Wifi',
  mixins: [SirinaOkna, StoritevEnum, StringConverter, SlovenianCurrencyMixin],
  data () {
    return {
      seznamStoritev: [
        StoritevEnum.NAJEM_WIFI_MESH_OPREME,
        StoritevEnum.WIFI_STORITEV,
        StoritevEnum.NAJEM_WIFI_OPREME,
        StoritevEnum.NAJEM_WIFI_6_MASH_OPREME
      ],
      storitevZaIzpis: [],
      storitevPovezava: '',
      nalaganjePaketovWifi: false,
      seznamNarocenihIzpis: [],
      seznamVklopljenihZaIzpis: [],
      expandRowKeys: [],
      formaOrientacija: 'left',
      mejnaSirina: 330,
      prikazTabele: '1',
      mejnaSirinaTabela: 1407,
      expandRowKeysNaroceno: [],
      nalganjeNarocenihStoritev: false,
      nalganjeVklopljenihStoritev: false,
      prikaziGumbZaNastavitev: false,
      kolicinaZaNarocanje: 1,
      numbers: Array.from({ length: 10 }, (_, i) => i + 1)
    }
  },
  props: {
    izbranPrikljucek: null,
    seznamNarocenWifi: null,
    seznamVkloplenWifi: null,
    seznamWifi: null
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetNaborWIFIStoritev()
        this.GetSeznamOpreme()
      }
    }
  },
  components: {
    IzdelkiBox,
    Izdelek,
    OrderExistsInfo,
    OrderButton,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Col.name]: Col,
    [Tooltip.name]: Tooltip,
    [MessageBox.name]: MessageBox,
    Order
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.OsveziPodatke()
    this.GetNaborWIFIStoritev()
    this.GetSeznamOpreme()
  },
  methods: {
    GetTekstSpremembaWifiOpreme (pvp) {
      if (pvp.vklopljena) {
        return 'Ste prepričani, da želite odjaviti ' + pvp.naziv + '?'
      } else {
        return 'Za naročilo ' + pvp.naziv + ' prosimo, izberite količino opreme, ki jo želite naročiti:'
      }
    },
    getStoritevById (id) {
      for (let i = 0; i < this.storitevZaIzpis.length; i++) {
        if (this.storitevZaIzpis[i].idStoritevVrstaIzbira === id) {
          return this.storitevZaIzpis[i]
        }
      }
      return null
    },
    OsveziPodatke () {
      this.GetVklopljeneStoritve()
      this.GetNaroceneStoritve()
    },
    GetSeznamOpreme () {
      if (this.izbranPrikljucek !== '') {
        this.seznamOpreme = []
        let param = ['filter[id_prikljucek]=' + this.izbranPrikljucek]
        param.push('permissionId=TR_OPREMA')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetSeznamOpreme',
          'ErrSeznamOpreme')
      }
    },
    SetSeznamOpreme (podatki) {
      this.prikaziGumbZaNastavitev = false
      this.seznamOpreme = podatki.permission.additionalData
      if (this.seznamOpreme.length > 0) {
        this.prikaziGumbZaNastavitev = true
      }
    },
    ErrSeznamOpreme (podatki) {
      this.ShowWarningMessage(podatki)
    },
    IzbiraVrsticeZaPrikazVklopljenihStoritev (row) {
      const id = row.idStoritev
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    IzbiraVrsticeZaPrikazNarocenihStoritev (row) {
      const id = row.idStoritev
      const lastId = this.expandRowKeysNaroceno[0]
      this.expandRowKeysNaroceno = id === lastId ? [] : [id]
    },
    GetNaborWIFIStoritev () {
      this.nalaganjePaketovWifi = true
      if (this.izbranPrikljucek !== '') {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        this.clientAgent.postWsRequest(this,
          'prikljucek/storitve/getNaborWifiPaketov?',
          param,
          null,
          'SetNaborWifiStoritev',
          'ErrNaborWifiStoritev')
      }
    },
    SetNaborWifiStoritev (podatki) {
      this.storitevZaIzpis = []
      for (let i = 0; i < podatki.data.length; i++) {
        podatki.data[i].vklopljena = false
        podatki.data[i].narocena = false
        if (podatki.data[i].idStoritevVrstaIzbira !== null) {
          podatki.data[i].loading = false
          this.storitevZaIzpis.push(podatki.data[i])
        } else {
          this.storitevPovezava = podatki.data[i]
          if ('cena' in this.storitevPovezava) {
            Vue.set(this.storitevPovezava, 'cenaSI', this.PikeVVejice(this.storitevPovezava.cena))
          }
        }
      }
      for (let i = 0; i < this.storitevZaIzpis.length; i++) {
        if ('cena' in this.storitevZaIzpis[i]) {
          Vue.set(this.storitevZaIzpis[i], 'cenaSI', this.PikeVVejice(this.storitevZaIzpis[i].cena))
        }
      }
      this.nalaganjePaketovWifi = false
      this.GetVklopljeneStoritve()
      this.GetNaroceneStoritve()
    },
    ErrNaborWifiStoritev (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalaganjePaketovWifi = false
    },
    GetVklopljeneStoritve () {
      this.nalganjeVklopljenihStoritev = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('idVrsta[]=35')
      param.push('idVrsta[]=75')
      param.push('idStatus=1')
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/storitve/info',
        param,
        null,
        'SetVklopljeneStoritve',
        'ErrVklopljeneStoritve')
    },
    ErrVklopljeneStoritve (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalganjeVklopljenihStoritev = false
    },
    SetVklopljeneStoritve (podatki) {
      this.seznamVklopljenihZaIzpis = []
      for (let i = 0; i < podatki.seznamStoritev.length; i++) {
        let najdenaStoritev = this.getStoritevById(podatki.seznamStoritev[i].idStoritev)
        if (
          this.seznamStoritev.indexOf(podatki.seznamStoritev[i].idStoritev) > -1 &&
          podatki.seznamStoritev[i].kolicina > 0
        ) {
          if (podatki.seznamStoritev[i].opis === '') {
            podatki.seznamStoritev[i].opis = podatki.seznamStoritev[i].naziv
          }
          podatki.seznamStoritev[i].jeVPaketu = false
          if (najdenaStoritev !== null) {
            podatki.seznamStoritev[i].jeVPaketu = najdenaStoritev.vPaketu
          }
          this.seznamVklopljenihZaIzpis.push(podatki.seznamStoritev[i])
        }
        if (podatki.seznamStoritev[i].kolicina > 0 && najdenaStoritev !== null) {
          najdenaStoritev.vklopljena = true
        }
      }
      this.nalganjeVklopljenihStoritev = false
    },
    GetNaroceneStoritve () {
      this.nalganjeNarocenihStoritev = true
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('idVrsta[]=35')
      param.push('idVrsta[]=75')
      param.push('idStatus=0')
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/storitve/info',
        param,
        null,
        'SetTrenutnoNaroceneStoritve',
        'ErrTrenutnoNaroceneStoritve')
    },
    SetTrenutnoNaroceneStoritve (podatki) {
      this.seznamNarocenihIzpis = []
      for (let i = 0; i < podatki.seznamStoritev.length; i++) {
        if (
          this.seznamStoritev.indexOf(podatki.seznamStoritev[i].idStoritev) > -1 &&
          podatki.seznamStoritev[i].kolicina > 0
        ) {
          if (podatki.seznamStoritev[i].opis === '') {
            podatki.seznamStoritev[i].opis = podatki.seznamStoritev[i].naziv
          }
          this.seznamNarocenihIzpis.push(podatki.seznamStoritev[i])
        }
        if (podatki.seznamStoritev[i].kolicina > 0 && this.getStoritevById(podatki.seznamStoritev[i].idStoritev) !== null) {
          this.getStoritevById(podatki.seznamStoritev[i].idStoritev).narocena = true
        }
      }
      this.nalganjeNarocenihStoritev = false
    },
    ErrTrenutnoNaroceneStoritve (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalganjeNarocenihStoritev = false
    },
    narociWifiStoritev (idStoritev, value, item) {
      item.loading = true
      if (typeof value === 'undefined') {
        MessageBox.prompt(
          'Vnesite izbrano količino', 'Opozorilo', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[0-9]/
          }).then(({value}) => {
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('idStoritev=' + idStoritev)
          param.push('kolicina=' + parseInt(value))
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/storitve/narociWifiStoritev?',
            param,
            null,
            'SetNarociWifiStoritev',
            'ErrNarociWifiStoritev')
        }).catch((err) => {
          err = null
          this.nalaganjePoslovanje = false
        })
      } else if (!isNaN(value)) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('idStoritev=' + idStoritev)
        param.push('kolicina=' + parseInt(value))
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/narociWifiStoritev?',
          param,
          null,
          'SetNarociWifiStoritev',
          'ErrNarociWifiStoritev')
      }
    },
    SetNarociWifiStoritev (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowSuccessMessage({message: 'Vklop / odjava uspešna'})
      this.izklopVklopljeneNarocene()
      this.GetVklopljeneStoritve()
      this.GetNaroceneStoritve()
    },
    ErrNarociWifiStoritev (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    izklopVklopljeneNarocene () {
      this.storitevZaIzpis.forEach(item => {
        item.narocena = false
        item.vklopljena = false
        item.loading = false
      })
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/Wifi.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/Wifi.vue